import React, { useEffect } from "react";
import "./NoResults.scss";
import { useTranslation } from "react-i18next";

function NoResults() {
  const { t } = useTranslation();

  useEffect(() => {
    //console.log("no result effect");
    return () => {
      //console.log("loading progress done");
    };
  }, []);

  return <div className="no-results">{t("noResults")}</div>;
}
export default NoResults;
